// Auto-generated by vibesites deploy pipeline. Do not edit manually.
// Includes inherited overrides from: core -> theme-preferred -> american-landmark-preferred -> the-murray
// Generated: 2026-11-03T20:29:04.871Z
// Counts: 2 design, 82 content, 33 slot group, 3 collection binding, 8 section, 2 style

export const designOverrides = {
  "design._site.font.heading": {
    "cssVariable": "--vibe-font-heading",
    "overrideType": "VALUE",
    "value": "'Montserrat', sans-serif",
    "mappedField": null
  },
  "design._site.color.linkUnderline": {
    "cssVariable": "--vibe-color-link-underline",
    "overrideType": "VALUE",
    "value": "underline",
    "mappedField": null
  }
};

export const contentOverrides = {
  "accessibilityhero.title": {
    "overrideType": "VALUE",
    "customValue": "<h1>Accessibility</h1>",
    "generatedValue": null,
    "mappedField": null
  },
  "amenitieshero.title": {
    "overrideType": "VALUE",
    "customValue": "<h1>Amenities</h1>",
    "generatedValue": null,
    "mappedField": null
  },
  "amenitieslist.apartmentHeading": {
    "overrideType": "VALUE",
    "customValue": "<h2>Apartment Features</h2>",
    "generatedValue": null,
    "mappedField": null
  },
  "amenitieslist.communityHeading": {
    "overrideType": "VALUE",
    "customValue": "<h2>Community Amenities</h2>",
    "generatedValue": null,
    "mappedField": null
  },
  "amenitieslist.subtitle": {
    "overrideType": "VALUE",
    "customValue": null,
    "generatedValue": null,
    "mappedField": null
  },
  "amenitieslist.title": {
    "overrideType": "VALUE",
    "customValue": null,
    "generatedValue": null,
    "mappedField": null
  },
  "applynowhero.title": {
    "overrideType": "VALUE",
    "customValue": "<h1>Apply Now</h1>",
    "generatedValue": null,
    "mappedField": null
  },
  "contactform.form_block": {
    "overrideType": "VALUE",
    "customValue": "multihub-lead-form",
    "generatedValue": null,
    "mappedField": null
  },
  "contactform.form_title": {
    "overrideType": "VALUE",
    "customValue": "Test",
    "generatedValue": null,
    "mappedField": null
  },
  "contactform.form.form_header_text": {
    "overrideType": "VALUE",
    "customValue": "Schedule",
    "generatedValue": null,
    "mappedField": null
  },
  "contacthero.title": {
    "overrideType": "VALUE",
    "customValue": "<h1>Contact Us</h1>",
    "generatedValue": null,
    "mappedField": null
  },
  "ctasection.card1.description": {
    "overrideType": "VALUE",
    "customValue": "<p>Choose from our spacious <span data-type=\"field-token\" data-field=\"property_bedrooms_range\"></span> bedroom floor plans.</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "faqhero.title": {
    "overrideType": "VALUE",
    "customValue": "<h1>Frequently Asked Questions</h1>",
    "generatedValue": null,
    "mappedField": null
  },
  "fees.title": {
    "overrideType": "VALUE",
    "customValue": null,
    "generatedValue": null,
    "mappedField": null
  },
  "floorplanshero.title": {
    "overrideType": "VALUE",
    "customValue": "<h1>Floor Plans</h1>",
    "generatedValue": null,
    "mappedField": null
  },
  "floorplanslist.title": {
    "overrideType": "VALUE",
    "customValue": "<h2>Make Yourself at Home</h2>",
    "generatedValue": null,
    "mappedField": null
  },
  "footer.address": {
    "overrideType": "FIELD_MAPPING",
    "customValue": null,
    "generatedValue": null,
    "mappedField": null
  },
  "footer.copyright": {
    "overrideType": "VALUE",
    "customValue": "© 2026 All Rights Reserved.",
    "generatedValue": null,
    "mappedField": null
  },
  "footer.phone": {
    "overrideType": "FIELD_MAPPING",
    "customValue": null,
    "generatedValue": null,
    "mappedField": "property_call_tracking_phone"
  },
  "gallery.subtitle": {
    "overrideType": "VALUE",
    "customValue": null,
    "generatedValue": null,
    "mappedField": null
  },
  "gallery.title": {
    "overrideType": "VALUE",
    "customValue": null,
    "generatedValue": null,
    "mappedField": null
  },
  "google-tag-manager.container_id": {
    "overrideType": "FIELD_MAPPING",
    "customValue": null,
    "generatedValue": null,
    "mappedField": "custom_google_gtm_id"
  },
  "hero.subtitle": {
    "overrideType": "VALUE",
    "customValue": "<h2><span data-type=\"field-token\" data-field=\"property_bedrooms_range\"></span> Bedroom Apartments for Rent in <span data-type=\"field-token\" data-field=\"property_address_city\"></span>, <span data-type=\"field-token\" data-field=\"property_address_state\"></span></h2><h2></h2>",
    "generatedValue": null,
    "mappedField": null
  },
  "hero.title": {
    "overrideType": "VALUE",
    "customValue": "<h1>Welcome to <span data-type=\"field-token\" data-field=\"property_name\"></span></h1>",
    "generatedValue": null,
    "mappedField": null
  },
  "featuring/luxury-apartments-pool-oklahoma-city::hyperlocalhero.subtitle": {
    "overrideType": "VALUE",
    "customValue": "<h2>Enjoy luxury living with a pool at Liberty Pointe in Oklahoma City. Discover the perfect blend of comfort and luxury in our beautiful community.</h2>",
    "generatedValue": null,
    "mappedField": null
  },
  "featuring/luxury-apartments-pool-oklahoma-city::hyperlocalhero.title": {
    "overrideType": "VALUE",
    "customValue": "<h1>Luxury Apartments with Pool in OKC</h1>",
    "generatedValue": null,
    "mappedField": null
  },
  "interactivemaphero.title": {
    "overrideType": "VALUE",
    "customValue": "<h1>Interactive Map</h1>",
    "generatedValue": null,
    "mappedField": null
  },
  "json-ld-schema.override_phone": {
    "overrideType": "FIELD_MAPPING",
    "customValue": null,
    "generatedValue": null,
    "mappedField": "property_call_tracking_phone"
  },
  "neighborhoodcallout.description": {
    "overrideType": "FIELD_MAPPING",
    "customValue": null,
    "generatedValue": null,
    "mappedField": "property_home_neighborhood_blurb"
  },
  "neighborhoodcallout.title": {
    "overrideType": "VALUE",
    "customValue": "<h2>Explore <span data-type=\"field-token\" data-field=\"property_address_city\"></span> step by step.</h2>",
    "generatedValue": null,
    "mappedField": null
  },
  "neighborhoodhero.title": {
    "overrideType": "VALUE",
    "customValue": "<h1>Neighborhood</h1>",
    "generatedValue": null,
    "mappedField": null
  },
  "neighborhoodmap.category_order": {
    "overrideType": "VALUE",
    "customValue": null,
    "generatedValue": null,
    "mappedField": null
  },
  "pageblurb.form_block": {
    "overrideType": "VALUE",
    "customValue": "multihub-lead-form",
    "generatedValue": null,
    "mappedField": null
  },
  "pageblurb.scheduler.header_text": {
    "overrideType": "VALUE",
    "customValue": "Schedule",
    "generatedValue": null,
    "mappedField": null
  },
  "pagehero.subtitle": {
    "overrideType": "FIELD_MAPPING",
    "customValue": null,
    "generatedValue": null,
    "mappedField": null
  },
  "pagehero.title": {
    "overrideType": "VALUE",
    "customValue": null,
    "generatedValue": null,
    "mappedField": null
  },
  "petpolicyhero.title": {
    "overrideType": "VALUE",
    "customValue": "<h1>Pet Policy</h1>",
    "generatedValue": null,
    "mappedField": null
  },
  "privacypolicyhero.title": {
    "overrideType": "VALUE",
    "customValue": "<h1>Privacy Policy</h1>",
    "generatedValue": null,
    "mappedField": null
  },
  "propertycontactinfo.phone": {
    "overrideType": "FIELD_MAPPING",
    "customValue": null,
    "generatedValue": null,
    "mappedField": "property_call_tracking_phone"
  },
  "propertyoverview.pre_title": {
    "overrideType": "VALUE",
    "customValue": "<p>Your Search Ends Here</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "propertyoverview.title": {
    "overrideType": "VALUE",
    "customValue": "<h2>Welcome to <span data-type=\"field-token\" data-field=\"property_name\"></span></h2>",
    "generatedValue": null,
    "mappedField": null
  },
  "rentgrata-widget.property_id": {
    "overrideType": "FIELD_MAPPING",
    "customValue": null,
    "generatedValue": null,
    "mappedField": "custom_rentgrata_token"
  },
  "residentaccesshero.title": {
    "overrideType": "VALUE",
    "customValue": "<h1>Resident Access</h1>",
    "generatedValue": null,
    "mappedField": null
  },
  "reviewscallout.title": {
    "overrideType": "VALUE",
    "customValue": "<h3>What Residents Say About <span data-type=\"field-token\" data-field=\"property_name\"></span></h3>",
    "generatedValue": null,
    "mappedField": null
  },
  "reviewshero.title": {
    "overrideType": "VALUE",
    "customValue": "<h1>Reviews</h1>",
    "generatedValue": null,
    "mappedField": null
  },
  "schedule-tour-blurb.scheduler_block": {
    "overrideType": "VALUE",
    "customValue": "multihub-tour-scheduler",
    "generatedValue": null,
    "mappedField": null
  },
  "scheduleatourhero.title": {
    "overrideType": "VALUE",
    "customValue": "<h1>Schedule A Tour</h1>",
    "generatedValue": null,
    "mappedField": null
  },
  "sitemaphero.title": {
    "overrideType": "VALUE",
    "customValue": "<h1>Sitemap</h1>",
    "generatedValue": null,
    "mappedField": null
  },
  "thankyouhero.title": {
    "overrideType": "VALUE",
    "customValue": "<h1>Thank You</h1>",
    "generatedValue": null,
    "mappedField": null
  },
  "virtual-tour.subtitle": {
    "overrideType": "VALUE",
    "customValue": null,
    "generatedValue": null,
    "mappedField": null
  },
  "virtual-tour.title": {
    "overrideType": "VALUE",
    "customValue": null,
    "generatedValue": null,
    "mappedField": null
  },
  "virtualtourhero.title": {
    "overrideType": "VALUE",
    "customValue": "<h1>Virtual Tour</h1>",
    "generatedValue": null,
    "mappedField": null
  },
  "_head.favicon_url": {
    "overrideType": "FIELD_MAPPING",
    "customValue": null,
    "generatedValue": null,
    "mappedField": "property_icon"
  },
  "audioeye-widget.cta_location": {
    "overrideType": "VALUE",
    "customValue": "left-lower",
    "generatedValue": null,
    "mappedField": null
  },
  "betterbot-chatbot.embed_script": {
    "overrideType": "FIELD_MAPPING",
    "customValue": null,
    "generatedValue": null,
    "mappedField": "custom_betterbot_script"
  },
  "hyperlocal-links.show_header": {
    "overrideType": "VALUE",
    "customValue": "false",
    "generatedValue": null,
    "mappedField": null
  },
  "hyperlocal-links.title": {
    "overrideType": "VALUE",
    "customValue": null,
    "generatedValue": null,
    "mappedField": null
  },
  "knock-chatbot.api_token": {
    "overrideType": "FIELD_MAPPING",
    "customValue": null,
    "generatedValue": null,
    "mappedField": "custom_knock_company_token"
  },
  "petpolicy.stat_pet_fee_sublabel": {
    "overrideType": "VALUE",
    "customValue": null,
    "generatedValue": null,
    "mappedField": null
  },
  "petpolicycallout.body": {
    "overrideType": "FIELD_MAPPING",
    "customValue": null,
    "generatedValue": null,
    "mappedField": "property_pets_blurb"
  },
  "scheduleatour.form_block": {
    "overrideType": "VALUE",
    "customValue": "multihub-tour-scheduler",
    "generatedValue": null,
    "mappedField": null
  },
  "scheduleatour.form.self_guided_tour_link": {
    "overrideType": "FIELD_MAPPING",
    "customValue": null,
    "generatedValue": null,
    "mappedField": "custom_self_guided_tour_url"
  },
  "scheduleatour.form.thank_you_url": {
    "overrideType": "VALUE",
    "customValue": "/thank-you",
    "generatedValue": null,
    "mappedField": null
  },
  "scheduleatour.form.use_leads_tour_times": {
    "overrideType": "VALUE",
    "customValue": "true",
    "generatedValue": null,
    "mappedField": null
  },
  "thankyoucontent.body": {
    "overrideType": "FIELD_MAPPING",
    "customValue": null,
    "generatedValue": null,
    "mappedField": "property_thankyou_blurb"
  },
  "accessibilityhero.subtitle": {
    "overrideType": "VALUE",
    "customValue": "<p>At The Murray, streamlined living extends to the web. We're committed to making our digital experience welcoming and accessible to every visitor, so everyone can explore our Northlake community with ease.</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "amenitieshero.subtitle": {
    "overrideType": "VALUE",
    "customValue": "<p>Explore resort-inspired comforts made for streamlined Northlake living, from a swimming pool with expansive sundeck seating and an outdoor grilling area to a 24-hour fitness center, EV charging, package lockers, and a pet park. Inside, smart home technology, stainless appliances, white quartz counters, and custom walk-in closets bring the same polished ease home.</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "applynowhero.subtitle": {
    "overrideType": "VALUE",
    "customValue": "<p>Your spacious two- or three-bedroom home at The Murray is just a few clicks away, complete with smart home technology, renovated finishes, and resort-inspired amenities across from Northlake Mall. Apply online today and settle into connected Charlotte living with room to make it your own.</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "contacthero.subtitle": {
    "overrideType": "VALUE",
    "customValue": "<p><strong>Curious about life at The Murray?</strong> Our leasing team is ready to answer your questions on floor plans, availability, and tours at our connected Northlake location just across from Northlake Mall. Reach out today and take the next step toward your new Charlotte home.</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "favoriteplaces.body": {
    "overrideType": "VALUE",
    "customValue": "<p>From coffee runs to movie nights, the Northlake corner of Charlotte keeps the good stuff close. Explore our handpicked list of nearby favorites and find your new go-to spots around The Murray.</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "floorplanshero.subtitle": {
    "overrideType": "VALUE",
    "customValue": "<p><strong>Two- and three-bedroom homes with two full baths and room to spread out.</strong> Explore The Murray's spacious Northlake layouts below, each with open living space, a private patio or balcony, custom walk-in closets, and renovated finishes like stainless appliances, white quartz counters, and smart home technology.</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "galleryhero.subtitle": {
    "overrideType": "VALUE",
    "customValue": "<p><strong>Take a closer look at life at The Murray.</strong> Scroll through renovated interiors with white quartz kitchens, subway tile, and sunlit living rooms and bedrooms, then step outside to the resort-style pool and sundeck, 24-hour fitness center, fireside lounges, dog park, and playground. It all comes together against the green, easygoing backdrop of Charlotte's Northlake area.</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "neighborhoodhero.subtitle": {
    "overrideType": "VALUE",
    "customValue": "<p>Northlake living means Northlake Mall, AMC Northlake 14, and standout dining like Firebirds Wood Fired Grill are all just minutes from your door. With I-77, I-485, and Harris Boulevard close by—plus trails and lake views at Hornets Nest Park and Latta Nature Preserve—Uptown Charlotte, Huntersville, and the Lake Norman corridor stay easily within reach.</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "petpolicyhero.subtitle": {
    "overrideType": "VALUE",
    "customValue": "<p>At The Murray, four-legged family members are right at home with an on-site pet park and easy access to Northlake green space for walks and playtime. Explore our pet policy below to see how we make settling in simple for you and your pets.</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "privacypolicyhero.subtitle": {
    "overrideType": "VALUE",
    "customValue": "<p>At The Murray, protecting the personal information of our residents and visitors is part of delivering streamlined, worry-free living. Learn how we collect, use, and safeguard your data.</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "promopopup.image": {
    "overrideType": "VALUE",
    "customValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5690269169090560/019f6d60-373a-7429-9301-f590839b8046.webp",
    "generatedValue": null,
    "mappedField": null
  },
  "residentaccesshero.subtitle": {
    "overrideType": "VALUE",
    "customValue": "<p>Your resident portal puts life at The Murray at your fingertips—pay rent, submit and track maintenance requests, and manage your account online anytime. Stay in the loop with community updates and enjoy the same streamlined, connected convenience that defines everyday living in Northlake.</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "reviewshero.subtitle": {
    "overrideType": "VALUE",
    "customValue": "<p><strong>Residents keep coming back to the same things: a caring team and a community that just works.</strong> From simple, well-supported move-ins and fast, friendly maintenance to smart-home controls and standout amenities like valet trash, see why life at The Murray feels genuinely easy.</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "scheduleatourhero.subtitle": {
    "overrideType": "VALUE",
    "customValue": "<p><strong>See connected Northlake living for yourself.</strong> Walk our spacious two- and three-bedroom homes and resort-inspired amenities in person, or explore The Murray from anywhere with a virtual tour—book the option that fits your schedule today.</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "sitemaphero.subtitle": {
    "overrideType": "VALUE",
    "customValue": "<p>From floor plans and amenities to our Northlake neighborhood, explore everything The Murray has to offer.</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "thankyouhero.subtitle": {
    "overrideType": "VALUE",
    "customValue": "<p><strong>Thank you for reaching out — we've received your inquiry.</strong><br>The Murray leasing team will follow up with you soon, and we can't wait to show you connected Northlake living with spacious two- and three-bedroom layouts, smart home touches, and resort-inspired community comforts.</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "virtualtourhero.subtitle": {
    "overrideType": "VALUE",
    "customValue": "<p>Step inside The Murray from wherever you are and explore our spacious two- and three-bedroom layouts and resort-inspired amenities at your own pace. Take a self-guided tour of our Northlake community and picture your streamlined Charlotte everyday.</p>",
    "generatedValue": null,
    "mappedField": null
  }
};

export const slotGroupOverrides = {
  "amenitieslist.community_photo_5": {
    "sourceIndex": 8,
    "fieldOverrides": null
  },
  "footer.design_by_logo": {
    "sourceIndex": null,
    "fieldOverrides": {
      "alt": {
        "type": "VALUE",
        "customValue": "Repli Logo"
      }
    }
  },
  "pagehero.bg_image": {
    "sourceIndex": 6,
    "fieldOverrides": null
  },
  "contactus.form.submit_button": {
    "sourceIndex": null,
    "fieldOverrides": {
      "url": {
        "type": "VALUE",
        "customValue": "/thank-you"
      }
    }
  },
  "footer.nav_col2_link2": {
    "sourceIndex": null,
    "fieldOverrides": {
      "url": {
        "type": "VALUE",
        "customValue": "https://www.alapts.com/leadership"
      },
      "_target": {
        "type": "VALUE",
        "customValue": "_blank"
      }
    }
  },
  "footer.nav_col4_link1": {
    "sourceIndex": null,
    "fieldOverrides": {
      "url": {
        "type": "VALUE",
        "customValue": "https://www.alapts.com/careers"
      },
      "_target": {
        "type": "VALUE",
        "customValue": "_blank"
      }
    }
  },
  "footer.nav_col4_link3": {
    "sourceIndex": null,
    "fieldOverrides": {
      "url": {
        "type": "VALUE",
        "customValue": "https://icx.efrontcloud.com/@4157/americanlandmarkfund/login.aspx"
      },
      "_target": {
        "type": "VALUE",
        "customValue": "_blank"
      }
    }
  },
  "footer.nav_col4_link4": {
    "sourceIndex": null,
    "fieldOverrides": {
      "url": {
        "type": "VALUE",
        "customValue": "https://www.alapts.com/news"
      },
      "_target": {
        "type": "VALUE",
        "customValue": "_blank"
      }
    }
  },
  "footer.nav_col4_link5": {
    "sourceIndex": null,
    "fieldOverrides": {
      "url": {
        "type": "VALUE",
        "customValue": "/contact-us"
      }
    }
  },
  "header.schedule_tour_link": {
    "sourceIndex": null,
    "fieldOverrides": {
      "label": {
        "type": "VALUE",
        "customValue": "Contact us"
      },
      "url": {
        "type": "VALUE",
        "customValue": "/contact-us"
      }
    }
  },
  "header.utility_link_3": {
    "sourceIndex": null,
    "fieldOverrides": {
      "url": {
        "type": "VALUE",
        "customValue": "/contact-us"
      }
    }
  },
  "scheduleatourcallout.cta_link": {
    "sourceIndex": null,
    "fieldOverrides": {
      "url": {
        "type": "FIELD_MAPPING",
        "mappedField": "custom_self_guided_tour_url"
      },
      "_target": {
        "type": "VALUE",
        "customValue": "_blank"
      }
    }
  },
  "amenitieshomesection.amenity_1": {
    "sourceIndex": null,
    "fieldOverrides": {
      "alt": {
        "type": "VALUE",
        "customValue": "Outdoor swimming pool with lounge chairs and umbrellas"
      },
      "image": {
        "type": "VALUE",
        "customValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5690269169090560/019d02f0-8da2-70be-bd19-2c992e7d2d2c.webp"
      },
      "title": {
        "type": "VALUE",
        "customValue": "Sparkling Pool & Sundeck"
      }
    }
  },
  "amenitieshomesection.amenity_2": {
    "sourceIndex": null,
    "fieldOverrides": {
      "alt": {
        "type": "VALUE",
        "customValue": "Fitness center with cardio equipment including stationary bikes, a rowing machine, and a cable weight machine, along with a mirrored wall and medicine balls."
      },
      "image": {
        "type": "VALUE",
        "customValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5690269169090560/019d02f0-8b67-768f-bd5d-54e3f6fe3cef.webp"
      },
      "title": {
        "type": "VALUE",
        "customValue": "24-Hour Fitness Center"
      }
    }
  },
  "amenitieshomesection.amenity_3": {
    "sourceIndex": null,
    "fieldOverrides": {
      "alt": {
        "type": "VALUE",
        "customValue": "Dog park area with green grass and a bench, with apartment buildings and a parking lot in the background."
      },
      "image": {
        "type": "VALUE",
        "customValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5690269169090560/019d02f0-8b06-728e-9d24-68476b4dcf28.webp"
      },
      "title": {
        "type": "VALUE",
        "customValue": "On-Site Pet Park"
      }
    }
  },
  "amenitieslist.featured": {
    "sourceIndex": null,
    "fieldOverrides": {
      "alt": {
        "type": "VALUE",
        "customValue": "Outdoor swimming pool with lounge chairs and umbrellas."
      },
      "title": {
        "type": "VALUE",
        "customValue": "Swimming Pool with Expansive Sundeck Seating"
      },
      "eyebrow": {
        "type": "VALUE",
        "customValue": "Featured Amenity"
      },
      "image": {
        "type": "VALUE",
        "customValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5690269169090560/019e8a04-f78d-727c-959f-3e5ec2492ca1.webp"
      },
      "description": {
        "type": "VALUE",
        "customValue": "<p>The Murray's sparkling outdoor swimming pool is the community's warm-weather centerpiece, wrapped by an expansive sundeck with comfortable lounge seating and lush landscaping. Residents love it for a refreshing dip after work, easy afternoons soaking up the Charlotte sun, or gathering with neighbors on the weekend. It's resort-style relaxation just steps from your door.</p>"
      }
    }
  },
  "amenitieslist.in_home_image": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "VALUE",
        "customValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5690269169090560/019d02f0-8027-714d-85ef-bb2228d81c84.webp"
      },
      "alt": {
        "type": "VALUE",
        "customValue": "Modern kitchen with stainless steel appliances, white cabinets, and quartz countertops."
      }
    }
  },
  "favoriteplaces.place_1": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "VALUE",
        "customValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5690269169090560/019f14ef-e917-7709-80c7-f9ba2817a791.webp"
      },
      "alt": {
        "type": "VALUE",
        "customValue": "Mean Mug Coffee Company"
      },
      "title": {
        "type": "VALUE",
        "customValue": "Mean Mug Coffee Company"
      },
      "url": {
        "type": "VALUE",
        "customValue": "http://meanmugcoffeeco.com/"
      },
      "_target": {
        "type": "VALUE",
        "customValue": "_blank"
      }
    }
  },
  "favoriteplaces.place_2": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "VALUE",
        "customValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5690269169090560/019f14ef-eec3-75be-baf6-42f2fd5108bf.webp"
      },
      "alt": {
        "type": "VALUE",
        "customValue": "Firebirds Wood Fired Grill"
      },
      "title": {
        "type": "VALUE",
        "customValue": "Firebirds Wood Fired Grill"
      },
      "url": {
        "type": "VALUE",
        "customValue": "https://firebirdsrestaurants.com/charlotte-northlake"
      },
      "_target": {
        "type": "VALUE",
        "customValue": "_blank"
      }
    }
  },
  "favoriteplaces.place_3": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "VALUE",
        "customValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5690269169090560/019f14f0-2fa6-75c9-98b8-61aa6f0c17b2.webp"
      },
      "alt": {
        "type": "VALUE",
        "customValue": "AMC Northlake 14 movie theater"
      },
      "title": {
        "type": "VALUE",
        "customValue": "AMC Northlake 14"
      },
      "url": {
        "type": "VALUE",
        "customValue": "https://www.amctheatres.com/movie-theatres/charlotte/amc-northlake-14"
      },
      "_target": {
        "type": "VALUE",
        "customValue": "_blank"
      }
    }
  },
  "homefeaturessplit.image": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "VALUE",
        "customValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5690269169090560/019d02f0-8274-7647-8737-f2b45a8d6426.webp"
      },
      "alt": {
        "type": "VALUE",
        "customValue": "Exterior of a white apartment building with black accents and balconies, surrounded by green grass and trees."
      }
    }
  },
  "homegallerygrid.gallery_image_0": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "VALUE",
        "customValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5690269169090560/019d02f0-8027-714d-85ef-bb2228d81c84.webp"
      },
      "alt": {
        "type": "VALUE",
        "customValue": "Modern kitchen with stainless steel appliances, white cabinets, and quartz countertops."
      }
    }
  },
  "homegallerygrid.gallery_image_1": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "VALUE",
        "customValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5690269169090560/019d02f0-7eb8-779a-877b-819b0d01c1a1.webp"
      },
      "alt": {
        "type": "VALUE",
        "customValue": "Cozy bedroom with an orange bedspread, green accent wall, and a large window."
      }
    }
  },
  "homegallerygrid.gallery_image_2": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "VALUE",
        "customValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5690269169090560/019d02f0-9602-777e-8b04-d8eaf86ba623.webp"
      },
      "alt": {
        "type": "VALUE",
        "customValue": "Modern community lounge with two sofas, fireplace, and decor."
      }
    }
  },
  "homeintrosection.image": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "VALUE",
        "customValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5690269169090560/019d02f0-8a4c-7679-8144-c89ea5fea2ec.webp"
      },
      "alt": {
        "type": "VALUE",
        "customValue": "Modern kitchen and dining area with island, stainless steel refrigerator, white cabinets, and round dining table."
      }
    }
  },
  "neighborhoodctahomesection.image": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "VALUE",
        "customValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5690269169090560/019d02f0-ba1b-751e-a985-4b2b0116f740.webp"
      },
      "alt": {
        "type": "VALUE",
        "customValue": "Aerial view of apartment buildings and surrounding neighborhood."
      }
    }
  },
  "neighborhoodhomesection.image": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "VALUE",
        "customValue": "https://media.multihub.io/cdn-cgi/image/format=auto/property/5690269169090560/019e8a04-d4b7-73bc-859e-7789d1d75f4e.webp"
      },
      "alt": {
        "type": "VALUE",
        "customValue": "Green grass courtyard with a park bench and parking lot with cars in the background."
      }
    }
  },
  "pageblurb.image": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "VALUE",
        "customValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5690269169090560/019d02f0-8274-7647-8737-f2b45a8d6426.webp"
      },
      "alt": {
        "type": "VALUE",
        "customValue": "Exterior of a white apartment building with black accents and balconies, surrounded by green grass and trees."
      },
      "alt_text": {
        "type": "VALUE",
        "customValue": "Exterior of The Murray's white apartment building with black accents, balconies, and mature trees."
      }
    }
  },
  "pageblurb.photo_2": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "VALUE",
        "customValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5690269169090560/019d02f0-acad-756f-a4d0-b336625107df.webp"
      },
      "alt": {
        "type": "VALUE",
        "customValue": "Resort-style swimming pool with lounge chairs and umbrellas, adjacent to a white building with columns."
      },
      "alt_text": {
        "type": "VALUE",
        "customValue": "Resort-style swimming pool with lounge chairs and umbrellas beside a white columned building."
      }
    }
  },
  "pageblurb.photo_3": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "VALUE",
        "customValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5690269169090560/019d02f0-8027-714d-85ef-bb2228d81c84.webp"
      },
      "alt": {
        "type": "VALUE",
        "customValue": "Modern kitchen with stainless steel appliances, white cabinets, and quartz countertops."
      },
      "alt_text": {
        "type": "VALUE",
        "customValue": "Renovated kitchen with stainless steel appliances, white cabinetry, and quartz countertops."
      }
    }
  },
  "residentaccess.card_1": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "VALUE",
        "customValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5690269169090560/019d02f0-ba1e-714c-8ed3-fbab013a2e5f.webp"
      },
      "alt": {
        "type": "VALUE",
        "customValue": "Exterior of a multifamily apartment building with white siding, balconies, and wood accents around the entrance."
      },
      "title": {
        "type": "VALUE",
        "customValue": "Make a Payment"
      },
      "url": {
        "type": "VALUE",
        "customValue": "https://themurray.loftliving.com/login"
      },
      "_target": {
        "type": "VALUE",
        "customValue": "_blank"
      }
    }
  },
  "residentaccess.card_2": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "VALUE",
        "customValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5690269169090560/019d02f0-8027-714d-85ef-bb2228d81c84.webp"
      },
      "alt": {
        "type": "VALUE",
        "customValue": "Modern kitchen with stainless steel appliances, white cabinets, and quartz countertops."
      },
      "title": {
        "type": "VALUE",
        "customValue": "Resident Portal"
      },
      "url": {
        "type": "VALUE",
        "customValue": "https://themurray.loftliving.com/login"
      },
      "_target": {
        "type": "VALUE",
        "customValue": "_blank"
      }
    }
  },
  "residentaccess.card_3": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "VALUE",
        "customValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5690269169090560/019d02f0-8da2-70be-bd19-2c992e7d2d2c.webp"
      },
      "alt": {
        "type": "VALUE",
        "customValue": "Outdoor swimming pool with lounge chairs and umbrellas"
      },
      "title": {
        "type": "VALUE",
        "customValue": "Contact Us"
      },
      "url": {
        "type": "VALUE",
        "customValue": "/contact-us"
      },
      "_target": {
        "type": "VALUE",
        "customValue": "_self"
      }
    }
  }
};

export const collectionBindingOverrides = {
  "amenitieslist.carousel_images": {
    "limit": 1,
    "hiddenIds": null,
    "orderedIds": null,
    "hiddenIndices": null,
    "ordering": null,
    "customItems": null
  },
  "amenitieslist.items": {
    "limit": null,
    "hiddenIds": null,
    "orderedIds": null,
    "hiddenIndices": null,
    "ordering": null,
    "customItems": null
  },
  "propertyoverview.gallery_images": {
    "limit": null,
    "hiddenIds": null,
    "orderedIds": null,
    "hiddenIndices": null,
    "ordering": [
      0,
      1,
      2,
      3,
      4,
      5,
      6,
      7,
      8,
      9,
      10,
      11,
      12,
      13,
      14,
      15,
      16,
      17,
      18,
      19,
      20,
      21,
      22,
      23,
      24,
      25,
      26,
      27,
      28,
      29,
      30,
      31,
      32,
      33,
      34,
      35,
      36,
      37,
      38,
      39,
      40,
      41,
      42,
      43,
      44,
      45,
      46,
      47,
      48,
      49,
      50,
      51,
      52,
      53,
      54,
      55,
      56,
      57,
      58,
      59,
      60,
      61
    ],
    "customItems": null
  }
};

export const sectionOverrides = {
  "_global": [
    {
      "sectionId": "google-tag-manager",
      "blockId": "google-tag-manager",
      "position": 0
    },
    {
      "sectionId": "json-ld-schema",
      "blockId": "json-ld-schema",
      "position": 0
    },
    {
      "sectionId": "multihub-lead-capture",
      "blockId": "multihub-lead-capture",
      "position": 0
    },
    {
      "sectionId": "audioeye-widget",
      "blockId": "audioeye-widget",
      "position": 0
    },
    {
      "sectionId": "betterbot-chatbot",
      "blockId": "betterbot-chatbot",
      "position": 0
    },
    {
      "sectionId": "knock-chatbot",
      "blockId": "knock-chatbot",
      "position": 0
    },
    {
      "sectionId": "leasing-ai-pixel",
      "blockId": "leasing-ai-pixel",
      "position": 0
    }
  ],
  "home": [
    {
      "sectionId": "hyperlocal-links",
      "blockId": "hyperlocal-links",
      "position": 17
    }
  ]
};

export const styleOverrides = {
  "hero.subtitle": {
    "properties": {
      "textAlign": "center"
    }
  },
  "neighborhoodmap.category_order": {
    "properties": {
      "textAlign": "center"
    }
  }
};
